<template>

<core-modal-setting title="Size" :value="valueText" placeholder="Default">
        
    <core-input-checklist 
        :options="options"
        v-model="internalValue"
    />

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'

export default {

    mixins: [mixSetting],

    computed: {

        options: function() {

            return [
                {
                    value: 'default',
                    text: 'Default'
                },
                {
                    value: 'custom',
                    text: 'Custom'
                }
            ]

        }

    }

}

</script>

<style scoped>

</style>